import { forwardRef, useContext } from 'react'
import { SwitchContext } from './switch-context'
import { SwitchThumb } from '../styled-components'

const SwitchThumbComponent = forwardRef((props, forwardedRef) => {
  const { ...thumbProps } = props
  const context = useContext(SwitchContext)

  return (
    <SwitchThumb
      size={context?.size}
      data-state={context?.getState(context?.checked)}
      data-disabled={context?.disabled ? '' : undefined}
      {...thumbProps}
      ref={forwardedRef}
    />
  )
})

SwitchThumbComponent.displayName = 'SwitchThumb'

export default SwitchThumbComponent
